<script lang="ts" setup>
import { goalPositionRects } from './consts'
import GoalPositionRect from './GoalPositionRect.vue'
import type { GoalPosition } from './PitchPositionIndicator/types'

type Props = {
  disabled?: boolean
}
defineProps<Props>()

// model
const model = defineModel<GoalPosition>({
  default: null,
})

// methods
function toggleGoalPosition(position: GoalPosition): void {
  model.value = position === model.value ? null : position
}

function isSelected(value: GoalPosition): boolean {
  return model.value === value
}
</script>

<template>
  <svg
    :class="{
      'pointer-events-none': disabled,
      'opacity-25 grayscale': disabled,
    }"
    width="187"
    height="89"
    viewBox="0 0 187 89"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_11086_39713"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="187"
      height="89"
    >
      <rect
        width="187"
        height="89"
        fill="rgba(217,217,217,1)"
      />
    </mask>
    <g mask="url(#mask0_11086_39713)">
      <mask
        id="path-2-inside-1_11086_39713"
        fill="white"
      >
        <rect
          width="187"
          height="95"
          rx="4"
        />
      </mask>
      <rect
        width="187"
        height="95"
        rx="4"
        stroke="white"
        stroke-width="12"
        mask="url(#path-2-inside-1_11086_39713)"
      />
      <mask
        id="path-3-inside-2_11086_39713"
        fill="white"
      >
        <rect
          width="187"
          height="95"
          rx="4"
        />
      </mask>
      <rect
        width="187"
        height="95"
        rx="4"
        stroke="rgba(255,0,0,1)"
        stroke-width="12"
        stroke-dasharray="8 8"
        mask="url(#path-3-inside-2_11086_39713)"
      />
      <GoalPositionRect
        v-for="rect in goalPositionRects"
        :key="rect.position"
        :position="rect.position"
        :x="rect.x"
        :y="rect.y"
        :isSelected="isSelected(rect.position)"
        @click="toggleGoalPosition"
      />
    </g>
  </svg>
</template>
